import types from '@/store/types/PromocionesEmpresariales'
import Vue from 'vue';

const state = {

    //datos para Autorizacion
    datosPe:{},
    lugarDesarrollo:{},
    promociones:[],

    //datos para ampliacion
    objEnviadasNetTodos:{},
    objPromocionesNet:[]
}
const getters = {
    [types.getters.GetdatosPe]:(state) => {
        let objPe = state.datosPe;
        return objPe;
    },
    [types.getters.GetlugarDesarrollo]:(state) => {
        return state.lugarDesarrollo;
    },
    [types.getters.Getpromociones]:(state) => {
        return state.promociones;
    },
    [types.getters.GetPromocionesEnviadasNetTodos]:(state) => {
        return state.objEnviadasNetTodos;
    },
    [types.getters.GetPromocionesNet]:(state) => {
        return state.objPromocionesNet;
    },
}
const mutations = {
    [types.mutations.SetdatosPe]:(state, obj) => {
        
        state.datosPe = obj;
    },
    [types.mutations.SetlugarDesarrollo]:(state, obj) => {
        state.lugarDesarrollo = obj;
    },
    [types.mutations.Setpromociones]:(state, lstPe) => {
        state.promociones = lstPe;
    },
    [types.mutations.SetPromocionesEnviadasNetTodos]:(state, objEnviadasNetTodos) => {
        state.objEnviadasNetTodos = objEnviadasNetTodos;
    },
    [types.mutations.SetPromocionesNet]:(state, objPromocionesNet) => {
        state.objPromocionesNet = objPromocionesNet;
    },
    
}
const actions = {
    [types.actions.RegistrarPromocionEmpresarial]:({commit},pObj)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.post(`pajel/promocion_empresarial/add`,pObj).then(r=>{
                if(r.status===200)
                {
                    let obj = r.data.resultado;
                    obj.fechaDesde =  Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(obj.fechaDesde);
                    obj.fechaHasta =  Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(obj.fechaHasta);
                    commit(types.mutations.SetdatosPe,obj);
                }
                resolve(r);
            })
        })
    },
    [types.actions.ModificarPromocionEmpresarial]:({commit},pObj)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.put(`pajel/promocion_empresarial/update/${pObj.promocionEmpresarialId}`,pObj).then(r=>{
                let obj = r.data.resultado;
                obj.fechaDesde =  Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(obj.fechaDesde);
                obj.fechaHasta =  Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(obj.fechaHasta);
                
                commit(types.mutations.SetdatosPe,obj);
                resolve(r);
            })
        })
    },

    
    [types.actions.ObtenerPromocionEmpresarialFiltro]:({commit},pObj)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/list/${pObj.pSolicitudId}/${pObj.pTramiteId}/${pObj.pPersonaEmpresaId}/${pObj.pPersonaNaturalId}/${pObj.pRepresentanteLegalId}/${pObj.pEstadoPromocionEmpresarialId}`).then(r=>{
                
                var itemLst = [];
                r.data.forEach(function(itemProm){
                    itemProm.fechaDesde =  Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(itemProm.fechaDesde);
                    itemProm.fechaHasta =  Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(itemProm.fechaHasta);
                    itemLst.push(itemProm);
                });
                commit(types.mutations.Setpromociones,itemLst);
                resolve(r);
            })
        })
    },
    /* net */
    [types.actions.ObtenerPromocionesTodosNet]:({commit},pTramietId)=>{
        return new Promise ((resolve,reject)=>{
            
            Vue.prototype.$http.get(`pajel/promocion_empresarial/net/obtener_promocion/${pTramietId}`).then(r=>{
                commit(types.mutations.SetPromocionesEnviadasNetTodos,r.data)
                resolve(r);
            });
        });
    },
    [types.actions.ObtenerPromocionesNet]:({commit},obj)=>{
        return new Promise ((resolve,reject)=>{
            
            Vue.prototype.$http.get(`pajel/promocion_empresarial/net/list/${obj.pUsuarioEmpresaId}/${obj.pTipoAmpliacionModificacion}`).then(r=>{
                commit(types.mutations.SetPromocionesNet,r.data)
                resolve(r);
            });
        });
    },

    //POstgreee
    [types.actions.ObtenerPromocionEmpresarial]:({commit},pPromocionEmpresarialId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/find/${pPromocionEmpresarialId}`).then(r=>{
                commit(types.mutations.SetdatosPe,r.data)
                resolve(r);
            });
        });
    },
    [types.actions.Obtenernotificaciones]:({commit},ppersonaId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/xPersonaId/${ppersonaId}`).then(r=>{
                commit(types.mutations.SetdatosPe,r.data)
                resolve(r);
            });
        });
    },
    [types.actions.Obteneravisos]:({commit},ppersonaId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/xAvisoPersonaId/${ppersonaId}`).then(r=>{
                commit(types.mutations.SetdatosPe,r.data)
                resolve(r);
            });
        });
    },
    [types.actions.ActualizarAviso]:({commit},ppersonaId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.put(`pajel/promocion_empresarial/actualizarAvisoVisto/${ppersonaId}`).then(r=>{
                commit(types.mutations.SetdatosPe,r.data)
                resolve(r);
            });
        });
    },
    [types.actions.ObteneravisosLista]:({commit},ppersonaId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/xAvisoLista/${ppersonaId}`).then(r=>{
                commit(types.mutations.SetdatosPe,r.data)
                resolve(r);
            });
        });
    },
    [types.actions.ObtenerPromocion]:({commit},promocionId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/xPromocionLista/${promocionId}`).then(r=>{
                commit(types.mutations.SetdatosPe,r.data)
                resolve(r);
            });
        });
    },

    [types.actions.ObtenerPromocionEmpresarialxTramiteId]:({commit},pTramiteId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/xTramiteId/${pTramiteId}`).then(r=>{

                var obj = r.data;
                obj.fechaDesde =  Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY( r.data.fechaDesde);
                obj.fechaHasta =  Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY( r.data.fechaHasta);
                
                commit(types.mutations.SetdatosPe,obj);
                resolve(r);
            });
        });
    },
    [types.actions.ClonarPeEnviadaSolicitudNueva]:({commit},obj)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/copiar_peenviada_a_solicitudnueva/${obj.pUsuarioEmpresaId}/${obj.pOficinaId}/${obj.pTramiteId}`).then(r=>{
                resolve(r);
            });
        });
    },

    [types.actions.MigrarPromocionFisicayPajelv1]:({commit},pTramitePeId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/net/MigrarPromocionFisicayPajelv1/${pTramitePeId}`).then(r=>{
                resolve(r);
            });
        });
    },

    [types.actions.ObtenerDatosPromocion]:({commit}, pPromocionEmpresarialNetId) => {
        return new Promise ((resolve, reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/promocionEmpresarialNet/${pPromocionEmpresarialNetId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },
    
    [types.actions.ObtenerPromocionEmpresarialxTramiteIdV2]:({commit},pTramiteId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/xTramiteId/v2/${pTramiteId}`).then(r=>{

                var obj = r.data;
                obj.fechaDesde =  Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY( r.data.fechaDesde);
                obj.fechaHasta =  Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY( r.data.fechaHasta);
                
                commit(types.mutations.SetdatosPe,obj);
                resolve(r);
            });
        });
    },
        
    [types.actions.ObtenerLugarEntregaPremioNet]:({commit},pPromocionId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/net/PremiosLugaresEntregas/${pPromocionId}`).then(r=>{
                resolve(r);
            });
        });
    },
    [types.actions.ObtenerMecanicaNet]:({commit},pPromocionId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/promocion_empresarial/net/MecanicaParticipacion/${pPromocionId}`).then(r=>{
                resolve(r);
            });
        });
    },
}
export default {
    state,
    actions,
    getters,
    mutations
}